(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('swifSiteOrEquipment', swifSiteOrEquipment);

    function SiteOrEquipmentCtrl(
        $scope, $timeout, $window, swif, carto, swifPatrimoineReferentielService, goNetEndpointApi, swifRouteService, swifOpenbaseCompanyService
    ) {
        'ngInject';
        var $ctrl = this;
        $ctrl.route = swifRouteService;
        $ctrl.showCarto = swif.settings.app.features.showCarto;
        $ctrl.modules = swif.module.modules;
        $ctrl.token = $window.localStorage.getItem('token');
        $ctrl.display = {
            site: true,
            map: false,
            _map: false
        };


        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.ngModel.is_canadian = company.is_canadian;
            if($scope.ngModel.is_canadian){
                updateFilter()
            }
        })

        var API = { childOnCollapse: childOnCollapse };

        function childOnCollapse() {
                $scope.ngModel._collapsed = !$scope.ngModel._collapsed;
                if (!$scope.ngModel._collapsed){
                    $ctrl.display._map = true;
                     // We display the map with a delay, otherwise an offset appear
                    $timeout(() => {
                        displayMap();
                    }, 100);
                }
            }

        if (swif.module.modules.opengst_carto) {
            $ctrl.toggleDisplay = toggleDisplay;
            $ctrl.displayMap = displayMap;
        }
        if (!$scope.ngModel.site_details){
            delete $scope.ngModel.site_details;
        }
        $ctrl.filter = {};
        $ctrl.filter.restrictIds = false;
        var user = swif.user.getAuthenticatedUserData();
        var getPartner = swif.user.getPartner(['technical_site_ids']);
        // initialize currentChoice according to ngModel data
        $ctrl.onEquipmentChange = onEquipmentChange;
        // Get municipality value for Canadian site Search
        $ctrl.onMapInitialized = function (map) {
            $ctrl.map = map;
            setMapStuffFromSiteData();
        };


        function onMunicipalityChange(municipality) {
            $scope.ngModel.codemuni = municipality.codemuni;
            $scope.layer_id = municipality.layer_id;
            $scope.map_city_name = municipality.map_city_name;
        }

        $ctrl.isVSNFeature = swif.settings.app.features.isVSN;

        $ctrl.formatNameChoices = swifPatrimoineReferentielService.selectOneFormatNameChoice;

        this.$onInit = function () {
            $ctrl.fullView = _.contains(user.access_rights, 'openstc_full_view');
            $ctrl.isVSN = swif.settings.app.features.isVSN;
            this.onInit = $scope.onInit({$API: API});


            // Always show map on limited view - TG3476-VSN : show map by default for everyone
                if ($ctrl.modules.opengst_carto && (!$ctrl.fullView || $scope.ngModel.geo_point || $ctrl.isVSN || $scope.ngModel.is_canadian) && !$scope.ngModel.isTaskRange) {
                    $ctrl.display._map = true;
                    // We display the map with a delay, otherwise an offset appears-
                    $timeout(() => {
                        displayMap();
                    }, 1000);
                }

            // Sets default intervention parent site for task site if it's linked to an intervention
            // VSN feature only
            var siteOnTaskFeature = swif.settings.app.features.siteOnTask;
            if (!$scope.ngModel.site1 &&!$scope.ngModel.equipment_id && $scope.ngModel.project_id) {
                var params = {fields: ['site1', 'equipment_id', 'site_details']};
                var projectid = $scope.ngModel.project_id[0]
                var parent_site = swif.data.get('intervention', projectid, params)
                parent_site.then(function (data) {
                    $scope.ngModel.site1 = data.site1;
                    $scope.ngModel.site_details = data.site_details;
                    $scope.ngModel.equipment_id = data.equipment_id;
                });
            }


            function checkExistingSite (address){
                // To check if the site already exists in the database
                let filter = {}
                filter.fields = ['name', 'parcel_matricule', 'street', 'city', 'owners', 'cadastral_parcel']
                swif.data.addFilter(filter, 'name', 'ilike', address)
                swif.data.get('site', undefined, filter).then( data => {
                if (data.length > 0) {
                    $scope.ngModel.site1 = [data[0].id, data[0].name];
                    $scope.ngModel.siteDataDetails = data[0]
                    }
                })
            }

            let partner = $scope.ngModel.partner_id;
            if (partner && $scope.ngModel.is_canadian && $scope.ngModel.id === undefined) {
                checkExistingSite(partner[1]);
            }

            $ctrl.display.equipment = $scope.ngModel.equipment_id ? true:false;
            if (!$scope.ngModel.equipment_id && $scope.ngModel._display_equipment_id) {
                $ctrl.display.equipment = true;
            }

            // $scope.$watch('ngModel.service_id', function (){
            //     updateFilter();
            // });

            $scope.$watch('ngModel.site1', function(newV) {
                updateFilter();
                if (swif.module.modules.opengst_carto) {
                    setGeolocationFromSite(newV);
                }
                if ($scope.ngModel.is_canadian && newV){
                    // to display site details
                    let filter = {'fields': ['owners', 'street', 'city', 'parcel_matricule', 'cadastral_parcel']}
                    swif.data.get('site', newV[0], filter).then( data => {
                        $scope.ngModel.siteDataDetails = data
                        displayMap()
                    })
                }
                if (newV === false && $scope.ngModel.is_canadian) {
                    // Refresh map if delete site1 fields
                    $ctrl.display._map = false;
                    $timeout(()=>{
                        $ctrl.display._map = true;
                        displayMap()
                    }, 100);
                }
            });
        };

        function getGeoData (parcel_matricule, cadastral_parcel){
            // search and get all the needed data to display the parcel polygon on map
            let parcel_mat10 = parcel_matricule.slice(0, 10) // get parcel matricule 18 digits from db to convert in 10 digits
            goNetEndpointApi.getGoNetMapService($ctrl.token, parcel_mat10, $scope.map_city_name, $scope.layer_id).success(resp => {
                if (resp.features){
                    // Getting the coordinates of the parcel polygon
                    let polygone_coord = resp.features[0].geometry.rings[0]
                    let latLong = []
                    _.forEach(polygone_coord, function (coord) {
                        // Inverse lat and long to display the polygon on the map
                        latLong.push([coord[1], coord[0]])
                    })
                    $ctrl.polygon = L.polygon(latLong, {color: 'red'}).bindPopup("Matricule: " + parcel_mat10 + ", cadastre: " + cadastral_parcel).addTo($ctrl.map);
                    $ctrl.map.fitBounds($ctrl.polygon.getBounds());
                }
            }).error(function(data, status, header, config){
                console.log("data", data, "status", status, "header", header, "config", config)
                if (status === 401) {
                    alert('Connection error, please reload the modal')
                }
            })
        }

        function toggleDisplay (id) {
            $ctrl.display[id] = !$ctrl.display[id];
        }
        function displayMap() {
            if ($ctrl.display._map) {
                swif.resources.add(['leaflet']).then(function () {
                    $ctrl.display.map = true;
                    if ($scope.ngModel.is_canadian && $scope.ngModel.site1) {
                        // update filter to get municipality value as codemun or layer_id
                        updateFilter();
                        // Get polygon information to display it for canadian client on map
                        let siteId = $scope.ngModel.site1[0]
                        let filter = {'fields': ['owners', 'street', 'city', 'parcel_matricule', 'cadastral_parcel']}
                        swif.data.get('site', siteId, filter).then( result => {
                            if(result.parcel_matricule){
                                getGeoData(result.parcel_matricule, result.cadastral_parcel)
                            }
                        })
                    }
                    if ($ctrl.polygon && $scope.ngModel.site1 === false){
                        $ctrl.map.removeLayer($ctrl.polygon);
                        carto.leaflet.setDefaultCenterView($ctrl.map)
                    }
                });
            } else {
                $ctrl.display.map = false;
            }
        }
        function updateFilter () {
            $ctrl.filter = {
                equipments: {fields: ['name', 'complete_name', 'site_id', 'code_equipment']},
                sites:{},
                canadian_muni: {fields: ["name", "address", "codemuni", "layer_id", "map_city_name"]}
            };
            if ($scope.ngModel.is_canadian) {
                // we'll need codemuni an layer_id to get polygon and site information
                swif.data.get('canadian_municipalities', undefined, $ctrl.filter.canadian_muni).then(data => {

                    $scope.ngModel.municipality = [data[0].id, data[0].name];
                    $scope.ngModel.codemuni = data[0].codemuni;
                    $scope.layer_id = data[0].layer_id;
                    $scope.map_city_name = data[0].map_city_name;
                })
            }
            getPartner.then(function (partner) {
                if (partner){
                    if (!_.isEmpty(partner.technical_site_ids) && !['task', 'intervention'].includes($scope.ngModel._type)) {
                        swif.data.addFilter(
                            $ctrl.filter.sites,
                            'id', 'child_of', partner.technical_site_ids
                        );
                        $ctrl.filter.restrictIds = partner.technical_site_ids;
                    }
                }
            });
            var isInter = false;
            var isInterRequest = false;
            if ($scope.ngModel) {
                if ($scope.ngModel._type === 'intervention' || $scope.siteSubtitle === 'la tâche') {
                    isInter = true;
                } else if ($scope.ngModel._type === 'intervention_request' || $scope.siteSubtitle === 'la demande') {
                    isInterRequest = true;
                }


                // Don't update equipments filters if an equipment is already seleted
                if (!$scope.ngModel.equipment_id && $scope.ngModel.site1) {
                    var _sites = [$scope.ngModel.site1[0]];
                    swifPatrimoineReferentielService.getChildren($scope.ngModel.site1[0]).then(function (sites) {
                        sites.map((site) => {
                            _sites.push(site.id);
                        });
                    });
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'site_id', '=', _sites
                    );
                }

                if ($scope.ngModel.service_id && isInter) {
                    swif.data.addFilter(
                        $ctrl.filter.sites,
                        '|'
                    );
                    swif.data.addFilter(
                        $ctrl.filter.sites,
                        'service_ids.id', '=', $scope.ngModel.service_id[0]
                    );
                    swif.data.addFilter(
                        $ctrl.filter.sites,
                        'service_ids', '=', false
                    );
                }
            }
        }
        //Download location of all sites
        function downloadSiteLocation(siteid) {
            var params = {fields: ['geo_point', 'geometry', 'osm_zoom']};
            if ($ctrl.isVSN){
                var params = {fields: ['geo_point', 'geometry', 'osm_zoom', 'geo_polygon', 'geo_line',  'geo_multi_line', 'geo_multi_polygon']};
            }
            return swif.data.get('site', siteid, params);
        }
        function setGeolocationFromSite(newV) {
            if (newV) {
                downloadSiteLocation(newV[0]).then(function (data) {
                    $ctrl.site_data = data;
                    setMapStuffFromSiteData();
                });
            }
        }

        // TG3803 VSN - get a point from a geometry witch is not point type
        function getPointFromGeometry(site_data) {
            if (site_data.geo_polygon) {
                var geo_polygon = JSON.parse(site_data.geo_polygon)
                geo_polygon.coordinates[0].length = 1;
                geo_polygon.coordinates = geo_polygon.coordinates[0][0].reverse();
                return JSON.stringify(geo_polygon)
            }
            if (site_data.geo_line) {
                var geo_line = JSON.parse(site_data.geo_line)
                geo_line.coordinates.length = 1;
                geo_line.coordinates = geo_line.coordinates[0].reverse();
                return JSON.stringify(geo_line)
            }
            if (site_data.geo_multi_line) {
                var geo_multi_line = JSON.parse(site_data.geo_multi_line)
                geo_multi_line.coordinates[0].length = 1;
                geo_multi_line.coordinates = geo_multi_line.coordinates[0][0].reverse();
                return JSON.stringify(geo_multi_line)
            }
            if (site_data.geo_multi_polygon) {
                var geo_multi_polygon = JSON.parse(site_data.geo_multi_polygon)
                geo_multi_polygon.coordinates[0][0].length = 1;
                geo_multi_polygon.coordinates = geo_multi_polygon.coordinates[0][0].reverse();
                return JSON.stringify(geo_multi_polygon)
            }

            return false

        }

        function onEquipmentChange(equipment) {
            if (!$scope.ngModel.site1 && equipment.site_id) {
                $scope.ngModel.site1 = angular.copy(equipment.site_id);
            }
        }

        function setMapStuffFromSiteData() {
            if (!$ctrl.map || !$ctrl.site_data) {
                return;
            }
            $ctrl.isVSN = swif.settings.app.features.isVSN;
            if ($ctrl.site_data.geo_point) {

                // TG-3522 - show site pin
                if ($ctrl.isVSN && !$scope.ngModel.changeSiteFromMap) {
                    $scope.ngModel.latlng = $ctrl.site_data.geo_point
                } else {
                    var latlng = carto.leaflet.getLatLngFromPoint($ctrl.site_data.geo_point);
                    $ctrl.map.setView(latlng);
                }
                $scope.ngModel.changeSiteFromMap = false
            }
            // TG3803 VSN - get a point from a geometry witch is not point type, case when it's a new intervention
            else if ($ctrl.isVSN && !$scope.ngModel.id && ($ctrl.site_data.geo_polygon || $ctrl.site_data.geo_line
                || $ctrl.site_data.geo_multi_line || $ctrl.site_data.geo_multi_polygon)) {
                $scope.ngModel.latlng = getPointFromGeometry($ctrl.site_data)
            }
            if ($ctrl.isVSN && $ctrl.site_data.osm_zoom) {
                $ctrl.map.setZoom($ctrl.site_data.osm_zoom);
                $scope.ngModel.zoom = $ctrl.site_data.osm_zoom
            }
        }
        $ctrl._onInitMap = function () {
            if (swif.settings.app.features.showCarto) {
                $ctrl.display._map=true;
                // We display the map with a delay, otherwise an offset appears
                $timeout(() => {
                    $ctrl.displayMap();
                }, 100);
            }
        }
    }

    function swifSiteOrEquipment (swif, carto) {
        'ngInject';
        var d = angular.copy(swif.form.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.onInit = '&';
        d.scope.ngModel = '=';
        d.scope.siteDetails = '@';
        d.scope.siteSubtitle = '@';
        d.link = link;
        d.controller = SiteOrEquipmentCtrl;
        d.controllerAs = '$ctrl';
        d.templateUrl = 'partials/openstc/form_site_or_equipment.html';
        return d;

        function link (scope, element) {
            swif.form.watchNgRequired(scope, element);
        }
    }

})();
